<template>
  <div>
    <v-simple-table class="mb-4">
      <template v-slot:default>
        <thead @click="showRegional = !showRegional">
          <tr>
            <th class="text-center">
              {{ $t("actionsRegionalCanPerform") }}
              <v-icon class="float-right" color="primary" v-if="!showRegional"
                >mdi-plus-box</v-icon
              >
              <v-icon class="float-right" color="primary" v-else
                >mdi-minus-box</v-icon
              >
            </th>
          </tr>
        </thead>
        <tbody v-show="showRegional">
          <tr v-for="item in regionals" :key="item.descripttion">
            <td>{{ item.descripttion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table class="mb-4">
      <template v-slot:default>
        <thead @click="showLocal = !showLocal">
          <tr>
            <th class="text-center">
              {{ $t("actionsLocalCanPerform") }}

              <v-icon class="float-right" color="primary" v-if="!showLocal"
                >mdi-plus-box</v-icon
              >
              <v-icon class="float-right" color="primary" v-else
                >mdi-minus-box</v-icon
              >
            </th>
          </tr>
        </thead>
        <tbody v-show="showLocal">
          <tr v-for="item in locals" :key="item.descripttion">
            <td>{{ item.descripttion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table class="mb-4">
      <template v-slot:default>
        <thead @click="showAgent = !showAgent">
          <tr>
            <th class="text-center">
              {{ $t("actionsAgentCanPerform") }}

              <v-icon class="float-right" color="primary" v-if="!showAgent"
                >mdi-plus-box</v-icon
              >
              <v-icon class="float-right" color="primary" v-else
                >mdi-minus-box</v-icon
              >
            </th>
          </tr>
        </thead>
        <tbody v-show="showAgent">
          <tr v-for="item in agents" :key="item.descripttion">
            <td>{{ item.descripttion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table class="mb-4">
      <template v-slot:default>
        <thead @click="showCollectors = !showCollectors">
          <tr>
            <th class="text-center">
              {{ $t("actionsCollectorCanPerform") }}

              <v-icon class="float-right" color="primary" v-if="!showCollectors"
                >mdi-plus-box</v-icon
              >
              <v-icon class="float-right" color="primary" v-else
                >mdi-minus-box</v-icon
              >
            </th>
          </tr>
        </thead>
        <tbody v-show="showCollectors">
          <tr v-for="item in collectors" :key="item.descripttion">
            <td>{{ item.descripttion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="ml-2 caption">
      {{ this.$t("noteSomeActionsMayDepend") }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showRegional: false,
      showLocal: false,
      showAgent: false,
      showCollectors: false,
    };
  },
  computed: {
    regionals() {
      return [
        {
          descripttion: this.$t("logIntoTheSystem"),
        },
        {
          descripttion: this.$t("listBetsWinningLosingPending"),
        },
        {
          descripttion: this.$t("cancelBet"),
        },
        {
          descripttion: this.$t("listAgents"),
        },
        {
          descripttion: this.$t("activateSuspendConsultAgents"),
        },
        {
          descripttion: this.$t("activateSuspendAgents"),
        },
        {
          descripttion: this.$t("listLocalManagers"),
        },
        {
          descripttion: this.$t("createEditQueryLocal"),
        },
        {
          descripttion: this.$t("activateSuspendLocal"),
        },
        {
          descripttion: this.$t("createEditQueryRoutes"),
        },
        {
          descripttion: this.$t("listCollectors"),
        },
        {
          descripttion: this.$t("createEditConsultCollectors"),
        },
        {
          descripttion: this.$t("viewAgentNetworkFinancial"),
        },
        {
          descripttion: this.$t("viewFinancialStatements"),
        },
        {
          descripttion: this.$t("viewAffiliateReports"),
        },
        {
          descripttion: this.$t("makeAdjustmentsAndConsolidateThem"),
        },
        {
          descripttion: this.$t("accessToTheGeolocationOfAgents"),
        },
        {
          descripttion: this.$t("changeYourPassword"),
        },
      ];
    },
    locals() {
      return [
        {
          descripttion: this.$t("logIntoTheSystem"),
        },
        {
          descripttion: this.$t("viewYourAgentFinancialReport"),
        },
        {
          descripttion: this.$t("viewAffiliateReports"),
        },
        {
          descripttion: this.$t("listAgents"),
        },
        {
          descripttion: this.$t("activateSuspendConsultAgents"),
        },
        {
          descripttion: this.$t("activateSuspendAgents"),
        },
        {
          descripttion: this.$t("listBetsWinningLosingPending"),
        },
        {
          descripttion: this.$t("paidBets"),
        },
        {
          descripttion: this.$t("listCreditSales"),
        },
        {
          descripttion: this.$t("changeYourPassword"),
        },
      ];
    },
    agents() {
      return [
        {
          descripttion: this.$t("logIntoTheSystem"),
        },
        {
          descripttion: this.$t("viewFinancialReportsAgent"),
        },
        {
          descripttion: this.$t("listBetsWinningLosingPending"),
        },
        {
          descripttion: this.$t("validateVisitorBets"),
        },
        {
          descripttion: this.$t("placeDirectBets"),
        },
        {
          descripttion: this.$t("cancelBet"),
        },
        {
          descripttion: this.$t("paidBets"),
        },
        {
          descripttion: this.$t("sellAndListCreditSales"),
        },
        {
          descripttion: this.$t("changeYourPassword"),
        },
        {
          descripttion: this.$t("accessEventTable"),
        },
        {
          descripttion: this.$t("accessToAWeeklySummary"),
        },
        {
          descripttion: this.$t("affiliatePlayers"),
        },
        {
          descripttion: this.$t("registerCustomers"),
        },
      ];
    },
    collectors() {
      return [
        {
          descripttion: this.$t("logIntoTheSystem"),
        },
        {
          descripttion: this.$t("consultTheRoutesToCollect"),
        },
        {
          descripttion: this.$t("consultTheFinancialHistoryOfLinkedAgents"),
        },
        {
          descripttion: this.$t("performEntriesPayOrReceive"),
        },
        {
          descripttion: this.$t("consultEntriesMadeByManager"),
        },
        {
          descripttion: this.$t("changeYourPassword"),
        },
      ];
    },
  },
};
</script>
